import * as React from "react";

const SvgTableView = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#TableView_svg__a)" fill={color}>
      <path
        opacity={0.3}
        d="M18.65 9.15v1.9h-9.5v-1.9h9.5zm-5.7 5.7v-1.9h1.9v1.9h-1.9zm1.9 1.9v1.9h-1.9v-1.9h1.9zm-3.8-1.9h-1.9v-1.9h1.9v1.9zm5.7-1.9h1.9v1.9h-1.9v-1.9zm-7.6 3.8h1.9v1.9h-1.9v-1.9zm7.6 1.9v-1.9h1.9v1.9h-1.9z"
      />
      <path d="M18.65 7.25h-9.5c-1.045 0-1.9.855-1.9 1.9v9.5c0 1.045.855 1.9 1.9 1.9h9.5c1.045 0 1.9-.855 1.9-1.9v-9.5c0-1.045-.855-1.9-1.9-1.9zm0 1.9v1.9h-9.5v-1.9h9.5zm-5.7 5.7v-1.9h1.9v1.9h-1.9zm1.9 1.9v1.9h-1.9v-1.9h1.9zm-3.8-1.9h-1.9v-1.9h1.9v1.9zm5.7-1.9h1.9v1.9h-1.9v-1.9zm-7.6 3.8h1.9v1.9h-1.9v-1.9zm7.6 1.9v-1.9h1.9v1.9h-1.9zM6.3 16.75h-.95c-1.045 0-1.9-.855-1.9-1.9v-9.5c0-1.045.855-1.9 1.9-1.9h9.5c1.045 0 1.9.855 1.9 1.9v.95h-1.9v-.95h-9.5v9.5h.95v1.9z" />
    </g>
    <defs>
      <clipPath id="TableView_svg__a">
        <path fill={color} transform="translate(.6 .6)" d="M0 0h22.8v22.8H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTableView;
